export default "__VITE_ASSET__DL6b9fY___"